import { useCallback, useEffect, useRef, useState } from 'react'

export const CCQ_RETRY_MS = 4000
export const CCQ_READ_TRIES = 3

// For a read nothing else would rerun: an effect that depends on `retryToken` reruns a while after `retryLater()`.
export const useRetryLater = (): { retryToken: number; retryLater: () => void } => {
  const [retryToken, setRetryToken] = useState(0)
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null)

  const retryLater = useCallback(() => {
    if (timer.current !== null) {
      return
    }
    timer.current = setTimeout(() => {
      timer.current = null
      setRetryToken((previous) => previous + 1)
    }, CCQ_RETRY_MS)
  }, [])

  useEffect(
    () => () => {
      if (timer.current !== null) {
        clearTimeout(timer.current)
      }
    },
    [],
  )

  return { retryToken, retryLater }
}
